"use client";
import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  VStack,
  Spinner,
  Flex,
  Input,
} from "@chakra-ui/react";
import HeaderTools from "../../components/HeaderTools";
import api from "../../services/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const getTotalItems = (products = []) =>
  products.reduce((sum, item) => {
    const totalQuantity = Object.values(item.sizes || {}).reduce(
      (total, size) => total + (size.quantity || 0),
      0,
    );
    return sum + totalQuantity;
  }, 0);

export default function CartAbandoned() {
  const [carts, setCarts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const getAbandonedCarts = async () => {
      try {
        setLoading(true);
        const response = await api.get("/cart/abandoned");
        setCarts(response.data);
      } catch {
        toast.error(
          "Não foi possível buscar os carrinhos abandonados, entre em contato com o suporte.",
        );
      } finally {
        setLoading(false);
      }
    };

    getAbandonedCarts();
  }, []);

  const filteredCarts = carts.filter((cart) =>
    cart.client?.name?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <>
      <HeaderTools
        title="Carrinhos Abandonados"
        onClickSearch={() => setShowSearch((prev) => !prev)}
        showSearch
      />
      <Box
        padding={{ base: "16px", md: "20px" }}
        bg="gray.50"
        minHeight="100vh"
      >
        <VStack spacing={0} align="stretch">
          {loading ? (
            <Flex width="100%" justify="center">
              <Spinner />
            </Flex>
          ) : null}
          {showSearch && (
            <Input
              placeholder="Pesquisar..."
              backgroundColor="white"
              padding="15px"
              onChange={(e) => setSearch(e.target.value)}
            />
          )}
          {filteredCarts.map((cart, index) => (
            <Box
              key={cart.id}
              bg="white"
              p={{ base: 4, md: 6 }}
              cursor="pointer"
              _hover={{ bg: "gray.50" }}
              transition="background 0.2s"
              borderBottom={
                index < filteredCarts.length - 1 ? "1px solid #e0e0e0" : "none"
              }
              borderRadius={
                index === 0
                  ? "8px 8px 0 0"
                  : index === filteredCarts.length - 1
                    ? "0 0 8px 8px"
                    : "0"
              }
              onClick={() => navigate(`/painel/carrinhos-abandonados/${cart.id}`)}
            >
              <VStack align="start" spacing={2}>
                <Text
                  fontWeight="bold"
                  fontSize={{ base: "16px", md: "18px" }}
                  color="gray.800"
                >
                  {cart.client?.name}
                </Text>
                <Text fontSize={{ base: "14px", md: "16px" }} color="gray.800">
                  {cart.client?.email}
                </Text>
                <Text fontSize={{ base: "14px", md: "15px" }} color="gray.600">
                  Atualizado em{" "}
                  {new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  }).format(new Date(cart.updatedAt))}
                </Text>
                <Text
                  fontWeight="bold"
                  fontSize={{ base: "16px", md: "18px" }}
                  color="gray.800"
                >
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(cart.totalValue)}
                </Text>
                <Text fontSize={{ base: "12px", md: "13px" }} color="gray.500">
                  {getTotalItems(cart.products)} ite
                  {getTotalItems(cart.products) === 1 ? "m" : "ns"} no carrinho
                </Text>
              </VStack>
            </Box>
          ))}
        </VStack>

        {!loading && filteredCarts.length === 0 && (
          <Box textAlign="center" py={10}>
            <Text color="gray.500" fontSize={{ base: "14px", md: "16px" }}>
              Nenhum carrinho abandonado encontrado.
            </Text>
          </Box>
        )}
      </Box>
    </>
  );
}
